/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{display:inline-block;width:50%}.close-icon[_ngcontent-%COMP%]{float:right;font-size:11px}.close-icon[_ngcontent-%COMP%]:hover{color:#d3d3d3}.app-modal-content[_ngcontent-%COMP%]{height:calc(100% - 51px)!important;width:100%}\n/*# sourceMappingURL=layer-preview-modal.component.css.map*/"];
export { styles as styles };
